/**
 * Copyright(c) 2022 Fenix Outdoor International AG.
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Fenix ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Fenix.
 *
 */
import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import Button from "../../../common/core/Button";
import Row from "../../../common/core/Row";
import Col from "../../../common/core/Col";
import Spinner from "../../../common/core/Spinner";
import Permission from "../../../common/security/Permission";
import Rules from "../../../common/security/PermissionRules";

const SeasonsData = (props) => {
  const {
    seasons,
    isLoading,
    toggleEditModal,
    handleDeleteConfirmationModal,
  } = props;
  return (
    <>
      <ul className="season-list">
        {seasons && !isLoading ? (
          <>
            {
              seasons && Array.isArray(seasons) && seasons.map((season) => (
                <li className="season-list-item">
                  <Row>
                    <Col className="text-primary">
                      {season.seasonId || <>&mdash;</>}
                    </Col>
                    <Col>
                      {season.countryId || <>&mdash;</>}
                    </Col>
                    <Col xs="3">
                      {season.seasonName || <>&mdash;</>}
                    </Col>
                    <Col xs="2">
                      {season.seasonGroup || <>&mdash;</>}
                    </Col>
                    <Col>
                      {season.startDate
                        ? moment(season.startDate).format("DD-MM-YYYY") : <>&mdash;</>}
                    </Col>
                    <Col>
                      {season.endDate
                        ? moment(season.endDate).format("DD-MM-YYYY") : <>&mdash;</>}
                    </Col>
                    <Col xs="1" className="justify-content-center">
                      <Permission
                        allowed={Rules.Control.EDIT_SEASON}
                      >
                        <Button color="transparent" className="btn-edit" onClick={() => toggleEditModal(season)}>
                          <i className="fal fa-pencil-alt"> </i>
                        </Button>
                      </Permission>
                      <Permission
                        allowed={Rules.Control.DELETE_SEASON}
                      >
                        <Button color="transparent" className="btn-delete" onClick={() => handleDeleteConfirmationModal(season)}>
                          <i className="fal fa-trash-alt"> </i>
                        </Button>
                      </Permission>
                    </Col>
                  </Row>
                </li>
              ))
            }
          </>
        ) : (
          <div className="spinner-load d-flex align-items-center justify-content-center">
            <Spinner />
          </div>
        )}
      </ul>
    </>
  );
};

SeasonsData.propTypes = {
  seasons: PropTypes.arrayOf(PropTypes.any).isRequired,
  isLoading: PropTypes.bool.isRequired,
  toggleEditModal: PropTypes.func.isRequired,
  handleDeleteConfirmationModal: PropTypes.func.isRequired,
};

export default SeasonsData;
